import type { LocalizedText } from "../../api/CertRoadmap/types";
import type { RoadmapLanguage } from "./types";

export const localizedText = (
  value: LocalizedText | string | null | undefined,
  language: RoadmapLanguage
) => {
  if (!value) return "";
  if (typeof value === "string") return value;

  const fallbackLanguage = language === "en" ? "ar" : "en";
  return value[language]?.trim() || value[fallbackLanguage]?.trim() || "";
};
